// ABOUTME: Dropdown selector for filtering by sport/workout type
// ABOUTME: Shows only workout types that have data (distance or duration > 0)

import type { FC } from "react"
import { useTranslation } from "react-i18next"
import type { WorkoutType } from "@/graphql/main/gql/graphql"
import { CSelect } from "./CSelect"

interface WorkoutTypeStats {
  type: WorkoutType
  distanceKm: number
  durationSeconds: number
}

interface SportTypeSelectorProps {
  value: WorkoutType | "all"
  onChange: (value: WorkoutType | "all") => void
  workoutTypes: WorkoutTypeStats[]
  className?: string
}

export const SportTypeSelector: FC<SportTypeSelectorProps> = ({
  value,
  onChange,
  workoutTypes,
  className = "min-w-[130px]",
}) => {
  const { t } = useTranslation()

  const filteredTypes = workoutTypes
    .filter((wt) => wt.distanceKm > 0 || wt.durationSeconds > 0)
    .sort((a, b) => b.distanceKm - a.distanceKm)

  return (
    <CSelect
      value={value}
      onChange={(e) => onChange(e.target.value as WorkoutType | "all")}
      className={className}
    >
      <option value="all">{t("statistics.sportType.all")}</option>
      {filteredTypes.map((wt) => (
        <option
          key={wt.type}
          value={wt.type}
        >
          {t(`statistics.workoutTypes.${wt.type}`)}
        </option>
      ))}
    </CSelect>
  )
}
